import { MixpanelContext } from 'app/mixpanel/MixPanelProvider';
import { useContext } from 'react';

export const useMixPanel = () => useContext(MixpanelContext);
